import { useEffect, useState } from "react";

import { logger } from "@formant/core/common/logger";

let contexts = 0;
const maxContexts = 8;

export function getWebglContext() {
    const supported = hasWebgl();
    if (!supported || contexts >= maxContexts) {
        logger.warn("No WebGL context avilable");
        return false;
    }
    contexts++;
    return true;
}

export function freeWebglContext() {
    contexts--;
}

export function hasWebgl(): boolean {
    try {
        const canvas = document.createElement("canvas");
        return !!window.WebGLRenderingContext && !!canvas.getContext("webgl");
    } catch (_) {
        return false;
    }
}

export const useWebglContext = () => {
    const [enabled, setEnabled] = useState<boolean | null>(null);
    useEffect(() => {
        setEnabled(getWebglContext());
        return () => {
            freeWebglContext();
        };
    }, [setEnabled]);
    return enabled;
};
